(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/depositLimits/set-deposit-limits.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/depositLimits/set-deposit-limits.js');
'use strict';

const {
  useState,
  useEffect,
  Fragment
} = React;
const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const {
  Footer,
  Header,
  DesktopContentConstrain,
  PageTitle,
  FadeInSlideWrapper
} = svs.playerRegistration.components;
const {
  GridBase
} = svs.tb_ui_react.gridbase;
const {
  SetDepositLimitsFormDropdown,
  SetDepositLimitsConfirm,
  LimitCoverageInfo,
  LimitCoverageWarning,
  DepositLimitsFAQ
} = svs.accountservicesReact.gameLimitDepositsForm;
const helpers = svs.playerRegistration.helpers;
const {
  routes
} = svs.playerRegistration.constants;
const {
  showHandleDoItLaterDialog,
  showLimitWarningDialog
} = svs.playerRegistration.dialogs;
const service = svs.accountservicesReact.gameLimitDepositsForm.maxLimitsService;

const SetDepositLimits = () => {
  var _svs, _svs2;
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const amount = (extraData === null || extraData === void 0 ? void 0 : extraData.amount) || null;
  const product = (extraData === null || extraData === void 0 ? void 0 : extraData.product) || null;
  const preDefinedLimitsSupporternEnabled = helpers.getPreDefinedLimitsSupporternEnabled();
  const returnUrl = helpers.getReturnUrl();
  const isInRegisterFlow = helpers.getIsInRegisterFlow(extraData === null || extraData === void 0 ? void 0 : extraData.setLimits);
  const history = useHistory();
  const isUnderTwenty = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerRegistration) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.isUnderTwenty) || false;
  const isTwentyToTwentyFive = ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerRegistration) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.isTwentyToTwentyFive) || false;
  const [step, setStep] = useState('form');
  const suggestedLimitsABTest = svs.components.targeting.isTargeted('COT_Insattningsgranser_FastaBelopp', 'B');
  const [dayLimit, setDayLimit] = useState(suggestedLimitsABTest ? '500' : null);
  const [weekLimit, setWeekLimit] = useState(suggestedLimitsABTest ? '500' : null);
  const [monthLimit, setMonthLimit] = useState(suggestedLimitsABTest ? '1000' : null);
  const [isPredefinedDayLimit, setIsPredefinedDayLimit] = useState(true);
  const [isPredefinedWeekLimit, setIsPredefinedWeekLimit] = useState(true);
  const [isPredefinedMonthLimit, setIsPredefinedMonthLimit] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [period, setPeriod] = useState(null);
  const [belowGameAmount, setBelowGameAmount] = useState(false);
  const [maxLimit, setMaxLimit] = useState();

  const calculateWarningMessage = () => {
    if (!isInRegisterFlow) {
      return false;
    }
    const minAmount = 25;
    const gameDataAmount = Number(extraData === null || extraData === void 0 ? void 0 : extraData.amount);

    if (!isNaN(dayLimit) && dayLimit !== '' && dayLimit >= minAmount && gameDataAmount > dayLimit || !isNaN(weekLimit) && weekLimit !== '' && weekLimit >= minAmount && gameDataAmount > weekLimit || !isNaN(monthLimit) && monthLimit !== '' && monthLimit >= minAmount && gameDataAmount > monthLimit) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (!product) {
      return;
    }
    const parsedAmount = parseInt(amount, 10);
    const parsedMonthLimit = parseInt(monthLimit, 10);
    const parsedWeekLimit = parseInt(weekLimit, 10);
    const parsedDayLimit = parseInt(dayLimit, 10);

    if (parsedMonthLimit === parsedAmount) {
      setPeriod('i denna månad');
    } else if (parsedWeekLimit === parsedAmount) {
      setPeriod('i denna vecka');
    } else if (parsedDayLimit === parsedAmount) {
      setPeriod('idag');
    } else {
      setPeriod(null);
    }

    if (parsedMonthLimit < parsedAmount && parsedMonthLimit >= 25 || parsedWeekLimit < parsedAmount && parsedWeekLimit >= 25 || parsedDayLimit < parsedAmount && parsedDayLimit >= 25) {
      setBelowGameAmount(true);
    } else {
      setBelowGameAmount(false);
    }
  }, [weekLimit, dayLimit, monthLimit, amount, product, period]);
  useEffect(() => {
    (async () => {
      const {
        data
      } = await service.getGamblingCareSpendLimitInfoAsync();
      const maxLimit = data === null || data === void 0 ? void 0 : data.spendLimit;
      if (maxLimit) {
        setMaxLimit(parseInt(maxLimit, 10));
      }
    })();
  }, []);
  const trackNavigation = (buttonName, product) => {
    svs.components.analytics.trackEvent({
      category: buttonName,
      action: 'limits_nav',
      opt_label: product || 'No product' 
    });
  };
  const handleFormIsDone = async (predefinedMonthLimit, predefinedWeekLimit, predefinedDayLimit) => {
    var _extraData$productInf;
    const isShowLimitWarning = calculateWarningMessage();
    let doContinue = true;
    if (isShowLimitWarning) {
      doContinue = await showLimitWarningDialog('Ditt spel kostar mer än din valda gräns', 'För att kunna lägga det här spelet behöver din gräns tillåta ett högre belopp. </br> Vill du ändra dina gränser, eller fortsätta ändå?', 'Fortsätt ändå', 'Ändra gränser');
    }
    setIsPredefinedMonthLimit(predefinedMonthLimit);
    setIsPredefinedWeekLimit(predefinedWeekLimit);
    setIsPredefinedDayLimit(predefinedDayLimit);
    trackNavigation('Fortsätt', (extraData === null || extraData === void 0 || (_extraData$productInf = extraData.productInfo) === null || _extraData$productInf === void 0 ? void 0 : _extraData$productInf.productDisplayName) || null);
    doContinue && setStep('confirm');
  };
  const navigateToDeposit = () => {
    var _extraData$productInf2;
    let urlString = '';
    const getSeparator = string => {
      if (string.includes('?')) {
        return '&';
      }
      return '?';
    };
    const trackLimits = () => {
      const trackingProductName = (extraData === null || extraData === void 0 ? void 0 : extraData.product) || 'No product';

      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_month',
        action: isPredefinedMonthLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(monthLimit, 10)
      });
      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_week',
        action: isPredefinedWeekLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(weekLimit, 10)
      });
      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_day',
        action: isPredefinedDayLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(dayLimit, 10)
      });
    };

    urlString += returnUrl ? "".concat(getSeparator(urlString), "returnUrl=").concat(returnUrl) : '';
    urlString += !isInRegisterFlow ? "".concat(getSeparator(urlString), "setLimits=1") : '';
    preDefinedLimitsSupporternEnabled && trackLimits();
    trackNavigation('Spara insättningsgränser', (extraData === null || extraData === void 0 || (_extraData$productInf2 = extraData.productInfo) === null || _extraData$productInf2 === void 0 ? void 0 : _extraData$productInf2.productDisplayName) || null);
    history.push("".concat(routes.DEPOSIT).concat(urlString)); 
  };
  const handleDoItLaterClick = async () => {
    var _extraData$productInf3;
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const betProduct = (extraData === null || extraData === void 0 || (_extraData$productInf3 = extraData.productInfo) === null || _extraData$productInf3 === void 0 ? void 0 : _extraData$productInf3.productDisplayName) || null;
    trackNavigation('Tillbaka till spelet', betProduct);
    showHandleDoItLaterDialog(betProduct, returnUrl);
    setIsButtonDisabled(false);
  };
  const pageTitleDepositLimits = suggestedLimitsABTest ? 'Välj hur mycket du vill kunna sätta in på ditt spelkonto' : 'Bestäm hur mycket du vill kunna sätta in';
  return React.createElement(Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, {
    className: "margin-xl-top-2 margin-lg-top-2 padding-xl-top-4 padding-lg-top-4"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 2
  })), React.createElement(FadeInSlideWrapper, null, React.createElement(PageTitle, null, step === 'form' && pageTitleDepositLimits || 'Dina insättningsgränser'), step === 'form' && React.createElement(Fragment, null, React.createElement("div", null, suggestedLimitsABTest && React.createElement(Fragment, null, React.createElement("p", {
    className: "f-medium"
  }, "Du v\xE4ljer sj\xE4lv det som passar dig."), React.createElement("p", null, " Gr\xE4nserna anger hur mycket pengar du som mest kan s\xE4tta in, inte hur mycket du m\xE5ste spela f\xF6r.")), React.createElement(SetDepositLimitsFormDropdown, {
    costOfGame: parseInt(amount, 10),
    dayLimit: dayLimit,
    infoMessage: period && !belowGameAmount ? React.createElement(LimitCoverageInfo, {
      amount: typeof amount === 'number' ? amount.toString() : amount,
      period: period,
      product: extraData.product
    }) : null,
    isTwentyToTwentyFive: isTwentyToTwentyFive,
    isUnderTwenty: isUnderTwenty,
    monthLimit: monthLimit,
    onDone: handleFormIsDone,
    setDayLimit: setDayLimit,
    setMonthLimit: setMonthLimit,
    setWeekLimit: setWeekLimit,
    warningMessage: (belowGameAmount || maxLimit && maxLimit < parseInt(amount, 10)) && React.createElement(LimitCoverageWarning, {
      amount: typeof amount === 'number' ? amount.toString() : amount,
      hasGameAmountOverMaxLimit: maxLimit < parseInt(amount, 10),
      isTwentyToTwentyFive: isTwentyToTwentyFive,
      isUnderTwenty: isUnderTwenty,
      maxLimit: maxLimit,
      product: extraData.product
    }) || '',
    weekLimit: weekLimit
  }), React.createElement(Button, {
    block: true,
    className: "margin-bottom-2",
    disabled: isButtonDisabled,
    onClick: handleDoItLaterClick,
    transparent: true
  }, product ? 'Tillbaka till spelet' : 'Gör senare')), React.createElement("section", {
    className: "margin-bottom-2"
  }, React.createElement("h2", {
    className: "f-700 margin-bottom-1 f-medium"
  }, "Bra att veta"), React.createElement("p", null, "Det finns inga krav p\xE5 att du ska s\xE4tta in pengar. Men du m\xE5ste s\xE4tta ins\xE4ttningsgr\xE4nser innan du spelar.")), React.createElement(DepositLimitsFAQ, null)), step === 'confirm' && React.createElement(SetDepositLimitsConfirm, {
    dayLimit: dayLimit,
    handleGoBack: () => {
      var _extraData$productInf4;
      trackNavigation('Ändra insättningsgränser', (extraData === null || extraData === void 0 || (_extraData$productInf4 = extraData.productInfo) === null || _extraData$productInf4 === void 0 ? void 0 : _extraData$productInf4.productDisplayName) || null);
      setStep('form');
    },
    monthLimit: monthLimit,
    onSaved: navigateToDeposit,
    weekLimit: weekLimit
  }), React.createElement(Footer, null)))));
};
svs.playerRegistration.pages.depositLimits.SetDepositLimits = SetDepositLimits;

 })(window);